export const truoraPath = "truora/token/";
export const decryptPath = "decoded?token=";
export const encryptPath = "encoded";
export const acceptPath = "truora/user/accept";
export const decryptPathAffidavit = "truora/token/decoded";
export const postAffidavitForm = "pipefy/affidavit/accept";
export const postUpdateTruoraData = "identity_document_validation/accept";
export const postAffidavitFormMx = "pipefy/affidavit/mx/accepts";
